export default {
  question: {
    label: 'questionfr',
    changeButton: 'changer la question secrète',
    titleChangeDialog: 'Changer de question Secrète',
    contact:
      "En cas d'oubli de la réponse à la question secrète, merci de contacter le CIEM",
    changeDialog: {
      label: 'Question secrète',
      response: 'Réponse',
    },
  },
}
